import { useEffect } from "react";
import { stores } from "../stores/rootStore";
import "./about.css";
import maker from "./img/maker2.png";
import vk from "./img/vk.png";
import instagram from "./img/inst.png";

export const About = () => {
  useEffect(() => {
    stores.helpUIStore.setTitle("о нас");
    stores.helpUIStore.setHistory(["about"]);
    //@ts-ignore
    fetch("https://maps.api.2gis.ru/2.0/loader.js?pkg=full")
      .then((v) => v.text())
      .then((v) => {
        Function(v)(); // eslint-disable-line
        //@ts-ignore
        return window.DG.then(() => true);
      })
      .then(() => {
        //@ts-ignore
        DG.then(function () {
          //@ts-ignore
          const map = DG.map("map", {
            center: [52.256815, 104.308872],
            zoom: 14,
          });
          //@ts-ignore
          var myIcon = DG.icon({
            iconUrl: maker,
            iconRetinaUrl: maker,
            iconSize: [25, 40],
            iconAnchor: [12, 40],
            // popupAnchor: [-3, -76],
            // shadowUrl: "my-icon-shadow.png",
            // shadowRetinaUrl: "my-icon-shadow@2x.png",
            // shadowSize: [68, 95],
            // shadowAnchor: [22, 94],
          });

          // DG.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
          //@ts-ignore
          DG.marker([52.256815, 104.308872], { icon: myIcon })
            .addTo(map)
            .bindPopup("Cvetochnaya lavka , ул. ​Верхняя Набережная, 145/11");
        });
      });
  }, []);
  return (
    <div className="about_wrapper">
      <div id="map"></div>
      <div className="about_foto"></div>
      <div className="about_info">
        <div className="about_item">
          <div>
            <div>ул. ​Верхняя Набережная, 145/11 </div>
            <div> 10.00 - 20.00</div>
            <div>+7 (952) 614-38-88</div>
          </div>
        </div>

        <div className="about_contacts">
          <a
            href="https://vk.com/club226331760"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="about_contact_item">
              <img src={vk} alt="Вконтакте" />
            </div>
          </a>

          <a
            href="https://www.instagram.com/cvetochnaya_lavka_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="about_contact_item">
              <img src={instagram} alt="Instagram" />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
